import { defineStore } from 'pinia';
import SettingsAplications from '@/core/settingsCoreAplications';
const Permissions = new SettingsAplications();
const apps = Permissions.apps;
const modulesApp = Permissions.modules;

export const useMenuStore = defineStore('menu', {
    state: () => {  
        return {
            classApps:apps,
            classModules:modulesApp,
            modules:{}
            
        }
    },
    getters: {
        getClassApps(state) {
            return state.classApps
        },
        getClassModules(state) {
            return state.classModules
        }
    },
    


})